import React from "react";
import { Col, Row } from "react-bootstrap";
import { object, number } from "prop-types";
import AverageScoreScale from "components/DynamicScoreReportScales/AverageScoreScale";
import exceededCheckCircle from "resources/images/dynamic_score_reports/skills/score-report/check-circle.png";
import currentCheckCircle from "resources/images/dynamic_score_reports/skills/score-report/hollow-check-circle.svg";
import { officeProficiencyDescriptions } from "../../constants";

const Office365 = (props) => {
  const { candidateInfo, SelectedScoreRangeSection, testId, testScores } =
    props;

  const score = testScores.get("stwenty");

  const ResultsDetails = (
    <div className="gray-bottom-border py-4 px-1">
      <h3 className="reportHeader pb-1">Results Details</h3>
      <p>
        Candidates receive a score from 1-20 and a proficiency rating from
        Beginner to Advanced. The score is a numerical reflection of the
        candidate's proficiency.
      </p>
      <p>
        {candidateInfo.get("testTakerFirstName")} received a score of {score} on
        the Microsoft {testScores.get("subTestName")} test, indicating that
        their proficiency is at the {testScores.get("label")} level.
      </p>
      {SelectedScoreRangeSection && (
        <Row className="mx-3 mt-4">
          <div className="selected-score-range-box office365">
            Selected Score Range
          </div>
          {SelectedScoreRangeSection}
        </Row>
      )}
    </div>
  );

  const getProficiencyDescriptions = () => {
    const proficiencyMap = officeProficiencyDescriptions[testId];

    const ProficiencyCols = [];

    Object.entries(proficiencyMap).forEach(([level, levelArr]) =>
      ProficiencyCols.push(
        <Col key={level} className="proficiency-col">
          <ul>
            {levelArr.map((desc) => (
              <li key={desc.substring(desc.length - 6, desc.length)}>{desc}</li>
            ))}
          </ul>
        </Col>
      )
    );

    return <Row className="py-3">{ProficiencyCols}</Row>;
  };

  const ProficiencySection = (
    <Row className="px-1 pt-4 pb-2">
      <Col>
        <p>
          The table below provides a summary of the knowledge and skills for
          each proficiency level. Note that the content areas included in the
          table are not exhaustive of each category.
        </p>
        <div className="mx-3">
          <AverageScoreScale score={score} testId={testId} />
          {getProficiencyDescriptions()}
        </div>
      </Col>
    </Row>
  );

  const ScoreKey = (
    <Row className="px-1 pb-4">
      <Col>
        <p style={{ color: "#6c757d", marginBottom: "10px" }}>Score Bar</p>
        <div className="mb-2">
          <img
            src={currentCheckCircle}
            alt="Current level"
            width="24"
            height="24"
            className="currentCheckCircle"
          />
          Indicates the <strong>current level of proficiency</strong> for the
          candidate. They are likely to be able to perform some of the functions
          in this category but not all.
        </div>
        <div>
          <img
            src={exceededCheckCircle}
            alt="Exceeded level"
            width="20"
            height="20"
            className="exceededCheckCircle"
          />
          Indicates the candidate has{" "}
          <strong>exceeded this level of proficiency</strong>. They are likely
          to be able to perform the functions included in this category.
        </div>
      </Col>
    </Row>
  );

  return (
    <div>
      {ResultsDetails}
      {ProficiencySection}
      {ScoreKey}
    </div>
  );
};

Office365.propTypes = {
  candidateInfo: object,
  SelectedScoreRangeSection: object,
  testId: number,
  testScores: object,
};

export default Office365;
